"use strict";import{tag as q}from"../custom-tag.js";export function enterGlobeIcon({height:l=16,width:e=16,hidden:t=!1,title:r="Enter globe"}={}){return q`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${e}
      height=${l}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${t?"true":"false"}"
      role="img"
      aria-label="${r}"
    >
      <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M18.6 21.156 12 13.324l-6.6 7.832h4.13V24h5.152v-2.844z"
        clip-rule="evenodd"
      />
      <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M9.531 23.757v-2.601zm-2.241-.702q.511.22 1.041.39v-1.09H5.903q.663.387 1.387.7M3.48 20.49q.247.248.508.479L5 19.769v-.3q-1.254-1.157-2.24-2.999h4.5q.054.246.111.484l1.925-2.284H8.79q-.12-.93-.15-1.515a24 24 0 0 1 0-2.37q.03-.555.15-1.485h6.45q.12.93.15 1.485t.03 1.155q0 .63-.03 1.215t-.15 1.515h-.537l1.94 2.303a27 27 0 0 0 .127-.503h4.47a10.7 10.7 0 0 1-2.445 3.055l1.217 1.444q.26-.231.508-.479a11.9 11.9 0 0 0 2.55-3.825Q24 14.46 24 11.94t-.93-4.695a12 12 0 0 0-2.55-3.795A11.7 11.7 0 0 0 16.71.915Q14.52 0 12 0T7.29.915 3.48 3.45A12 12 0 0 0 .93 7.245Q0 9.42 0 11.94t.93 4.725a11.9 11.9 0 0 0 2.55 3.825M8.06 18l1.11-1.319zm8.65 5.055q.724-.312 1.387-.7h-2.214v1.019q.42-.143.827-.319M2.16 14.67h4.77q-.09-.81-.105-1.455T6.81 11.94q0-.75.03-1.335T6.96 9.3h-4.8q-.21.72-.285 1.29T1.8 11.94t.075 1.395.285 1.335m14.88 0h4.8q.21-.72.285-1.335t.075-1.395-.075-1.35-.285-1.29h-4.77q.09 1.05.12 1.605t.03 1.035q0 .66-.045 1.245t-.135 1.485m-.3-7.17h4.5a9.7 9.7 0 0 0-2.715-3.45Q16.8 2.67 14.55 2.1q.75 1.11 1.275 2.4t.915 3m-7.62 0h5.82q-.33-1.59-1.11-3.075T12 1.8q-.96.81-1.62 2.13T9.12 7.5m-6.36 0h4.53q.33-1.62.84-2.895T9.42 2.13q-2.25.57-3.93 1.92T2.76 7.5"
        clip-rule="evenodd"
      />
    </svg>
  `}
//# sourceMappingURL=enterGlobe.js.map
